<template>
 <table class="table-inner">
    <tr class="table-row" :class="{is_main_row: !isFeedSlot}">

       <!-- If feed, display dropdown arrow -->
      <div v-if="slotObj.asset.asset_type == 6" class="btn-drop" @click="$emit('expandFeed')" :class="{expanded: expanded}"></div>

      <td class="slot-order-wrapper order cell" style="width:7%;" :class="{invisible: isFeedSlot}">
         <div class="slot-order">{{slotObj.order}}</div>
         <div class="slot-slot">Slot</div>
      </td>

      <td class="asset" style="width:34%;" :class="{add_margin: addRow}">
         <div class="slot-asset-wrapper">
            <div class="slot-asset-img-container">
               <div v-if="addRow" id="asset_drop_zone">
                  <img v-if="slotObj.recid == currSelectedSlot" @click="handleAssetClick" src="./../../../../assets/img/drag-and-drop-active.svg">
                  <img v-else @click="handleAssetClick" src="./../../../../assets/img/drag-and-drop-default.svg">
               </div>
               <div v-else class="thumb-wrapper" :class="{selected: slotObj.recid == currSelectedSlot}">
                  <img v-if="slotObj.asset.thumbnail != '' && slotObj.asset.thumbnail != undefined" data-recid="" class="slot-asset-thumb"
                        v-bind:src="this.GALLERY_HOST + '/' + slotObj.asset.thumbnail"
                        @click="handleAssetClick"
                     />
                  <img v-else-if="slotObj.asset.asset_type==3" style="padding:10px" 
                        src="../../../../assets/img/media/graphic-asset-card-audio.svg" 
                        class="slot-asset-thumb" @click="handleAssetClick"/>
                  <div class="img-overlay" :class="{active: active}">
                     <div class="overlay-wrapper">
                        <img id="remove_asset_btn">
                     </div>
                     <div class="overlay-background">
                     </div>
                  </div>
               </div>
            </div>

            <div class="asset-info-wrapper cell" v-if="!addRow">
                  <div class="asset-title" :class="{italic: addRow}">{{this.addRow ? 'Title' : assetTitle}}</div>
                  <div class="asset-created">Created by <span v-if="!addRow">{{slotObj.asset.contributor}}</span></div>
            </div>
         </div>
         
      </td>

      <td  class="slot-duration-wrapper duration cell" style="width:12%;">
         <span v-if="slotObj.asset.asset_type == 1" class="duration-input-wrapper">
            <input class="duration-input left" type="number" min="0" v-model="durHour" @change="handleDurationChange">:
            <input class="duration-input center" type="number" min="0" v-model="durMinute" @change="handleDurationChange">:
            <input class="duration-input right" type="number" min="0" v-model="durSecond" @change="handleDurationChange">
         </span>
         <span v-else-if="!addRow">
            <span>{{durHour}}</span>:<span>{{durMinute}}</span>:<span>{{durSecond}}</span>
         </span>
         <span>
         </span>
      </td>

      <td  class="slot-asset-type asset-type cell" style="width:9%;">
         <span v-if="!addRow">{{getAssetString(slotObj.asset.asset_type)}}</span>
      </td>

      <td  class="file-type cell" style="width:9%;">
         {{fileType}}
      </td>

      <td v-if="!addRow" class="status cell ready" style="width:12%;">
         <span>{{'Ready'}}</span>
      </td>

      <!-- Loop -->
      <td v-if="!addRow && slotObj.hasOwnProperty('loop')" class="check loop cell" style="width:5%;padding-left:8px;">
         <check v-show="slotObj.order!=1 || isFeedSlot" :isChecked="loop" :value="loop" @input="handleLoopCheck"></check>
      </td>

      <!-- Hot Pick -->
      <td v-if="!addRow && slotObj.hasOwnProperty('hotPick')" class="check hot-pick cell" style="width:5%;padding-left:13px;">
         <check v-show="slotObj.order!=1 || isFeedSlot" :isChecked="hotPick" :value="hotPick" @input="handleHotPickCheck"></check>
      </td>

      <!-- No Ads -->
      <td v-if="!addRow && slotObj.hasOwnProperty('noAds')" class="check no-ads cell" style="width:5%;padding-left:8px;">
         <check v-show="slotObj.order!=1 || isFeedSlot" :isChecked="noAds" :value="noAds" @input="handleNoAdsCheck"></check>
      </td>

      <td  class="buttons-cell" style="width:17%;">
         <div class="buttons-wrapper">
            <div v-if="!addRow && isTrigger" class="trigger-btn">Start</div>
            <div v-if="!addRow && slotObj.asset.asset_type == 10" @click="$emit('editInstance')" class="edit-btn btn"></div>
            <div v-if="!isFeedSlot && !(slotObj.order == 1 && isGameBlock)" @click="$emit('deleteSlot')" class="delete-btn btn"></div>
         </div>
      </td>
   </tr>
</table>
</template>

<script>
import {Draggable, Droppable, Sortable, Swappable} from '@shopify/draggable';
import BaseTableRow from './../../block_detail/BaseTableRow';

import { mapActions, mapState } from 'vuex';

export default { 
   extends: BaseTableRow,

   props: {
      feedSlots: Array
   },

   computed: {
      ...mapState([
         'isGameBlock'
      ]),

      ...mapState('program_block', [
         'currSelectedSlot'
      ]),

      hotPick() {
         return this.slotObj.hotPick;
      },

      loop() {
         return this.slotObj.loop;
      },

      noAds() {
         return this.slotObj.noAds;
      }
   },

   methods: {
      ...mapActions('program_block', [
         'editSlot',
         'editGameSlot',
         'changeSlotDuration',
         'changeFeedSlotDuration',
         'changeFeedSlotHotPick',
         'changeFeedSlotNoAds',
         'changeFeedSlotLoop',
         'changeSlotHotPick',
         'changeSlotNoAds',
         'changeSlotLoop',
      ]),

      handleAssetClick() {
         if (!this.isFeedSlot) {
            if (this.isGameBlock && this.slotObj.order == 1) {
               this.editGameSlot({slotRecid: this.slotObj.recid});
            } else {
               this.editSlot({slotRecid: this.slotObj.recid});
            }
         }
      },

      handleDurationChange() {
         if (this.durMinute == '') {
            this.durMinute = 0;
         } 
         if (this.durSecond == '') {
            this.durSecond = 0;
         }
         let totalDuration = (parseInt(this.durMinute) * 60) + (parseInt(this.durSecond));
         if (this.isFeedSlot) {
            this.changeFeedSlotDuration({slotRecid: this.slotRecid, assetRecid: this.slotObj.asset.recid, duration: totalDuration});
         } else {
            this.changeSlotDuration({slotRecid: this.slotObj.recid, duration: totalDuration});
         }
      },

      handleHotPickCheck(input) {
         if (this.isFeedSlot) {
            this.changeFeedSlotHotPick({slotRecid: this.slotRecid, assetRecid: this.slotObj.asset.recid, checked: input.checked});
         } else {
            this.changeSlotHotPick({slotRecid: this.slotObj.recid, checked: input.checked});
         }
      },

      handleNoAdsCheck(input) {
         if (this.isFeedSlot) {
            this.changeFeedSlotNoAds({slotRecid: this.slotRecid, assetRecid: this.slotObj.asset.recid, checked: input.checked});
         } else {
            this.changeSlotNoAds({slotRecid: this.slotObj.recid, checked: input.checked});
         }
      },

      handleLoopCheck(input) {
         if (this.isFeedSlot) {
            this.changeFeedSlotLoop({slotRecid: this.slotRecid, assetRecid: this.slotObj.asset.recid, checked: input.checked});
         } else {
            this.changeSlotLoop({slotRecid: this.slotObj.recid, checked: input.checked});
         }
      }
   }
}
</script>